import {inject, injectable} from "inversify";
import {AchievementHandlerInterface, AchievementInterface, RewarderInterface} from "@/modules/archiements/interfaces";
import {Team} from "@/modules/team/entity";
import {AchievementRewardsType, TYPES} from "../types";
import GateManager from "@/modules/action-points/services/GateManager";
import {GateTypeEnum} from "@/modules/action-points/enums";
import {BankCategory} from "@/modules/finances/enums";

@injectable()
export default class Rewarder implements RewarderInterface {
  constructor(
    @inject(GateManager) private gateManager: GateManager,
    @inject(TYPES.AchievementHandler) private achievementHandler: AchievementHandlerInterface,
  ) {}

  async rewardAchievement(achievement: AchievementInterface): Promise<void> {
    if (!achievement.achieved) {
      throw `Achievement '${achievement.type}' was not achieved.`;
    }

    if (achievement.rewarded) {
      throw `Achievement '${achievement.type}' has been rewarded already.`;
    }

    await this.reward(achievement.rewards);
    achievement.rewarded = true;

    await this.achievementHandler.save(achievement);
  }

  async reward(rewards: AchievementRewardsType): Promise<void> {
    const team = await Team.current();

    await Object.keys(rewards)
      .forEachAsync(async (gateType: GateTypeEnum, i: number) => {
        await this.gateManager.getGate(gateType).currency.add(
          rewards[gateType]!,
          {category: BankCategory.ACHIEVEMENTS, label: translator.t('achievement_completed')}
        );
      });

    await team.save();
  }
}
